import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { localStorageGetItem } from 'src/utils/storage-available';

import { defaultLang } from './config-lang';
import translationEn from './langs/en.json';
import translationFr from './langs/fr.json';
import translationAr from './langs/ar.json';
import translationDe from './langs/de.json';
import translationRu from './langs/ru.json';
import translationEs from './langs/es.json';
import translationDk from './langs/dk.json';
import translationIt from './langs/it.json';
import translationTr from './langs/tr.json';
import translationSv from './langs/sv.json';
import translationPt from './langs/pt.json';


// ----------------------------------------------------------------------

const lng = localStorageGetItem('i18nextLng', defaultLang.value);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: translationEn },
      fr: { translations: translationFr },
      de: { translations: translationDe },
      ar: { translations: translationAr },
      ru: { translations: translationRu },
      es: { translations: translationEs },
      nl: { translations: translationDk },
      it: { translations: translationIt },
      tr: { translations: translationTr },
      sv: { translations: translationSv },
      pt: { translations: translationPt },
    },
    lng,
    fallbackLng: 'en',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
